/* eslint-disable no-shadow */

import actions from './actions';
import mutations from './mutations';
import { isSupportMode } from '../../../lib/supportMode';

const state = {
  appId: null,
  id: null,
  name: '',
  subdomain: '',
  displayName: '',
  logoUri: '',
  parentId: null,
  parent: null,
  children: null,
  accessDetails: {},
  assuranceApiKey: null,
  assuranceTenant: null
};

const getters = {
  isSingleSite: (state) =>
    state.parentId === null && ((state.children && state.children.length === 0) || !state.children),

  hasCompliLearnSites: (state) =>
    Object.prototype.hasOwnProperty.call(state, 'accessDetails') &&
    Object.prototype.hasOwnProperty.call(state.accessDetails, 'hasCompliLearnSites') &&
    state.accessDetails.hasCompliLearnSites,

  isUgcEnabled: (state) =>
    Object.prototype.hasOwnProperty.call(state, 'accessDetails') &&
    Object.prototype.hasOwnProperty.call(state.accessDetails, 'isUgcEnabled') &&
    state.accessDetails.isUgcEnabled,

  isAssuranceIntegrationEnabled: (state) =>
    Object.prototype.hasOwnProperty.call(state, 'accessDetails') &&
    Object.prototype.hasOwnProperty.call(state.accessDetails, 'isAssuranceIntegrationEnabled') &&
    state.accessDetails.isAssuranceIntegrationEnabled,

  isSecureUgcModulesEnabled: (state) =>
    Object.prototype.hasOwnProperty.call(state, 'accessDetails') &&
    Object.prototype.hasOwnProperty.call(state.accessDetails, 'isSecureUgcModulesEnabled') &&
    state.accessDetails.isSecureUgcModulesEnabled,

  isContextKeyPreferencesEnabled: (state) =>
    Object.prototype.hasOwnProperty.call(state, 'accessDetails') &&
    Object.prototype.hasOwnProperty.call(state.accessDetails, 'isContextKeyPreferencesEnabled') &&
    state.accessDetails.isContextKeyPreferencesEnabled,

  // Hidden in support mode: the Mazlan agent does not forward x-support-site-uri, so it would 401.
  isMazlanAdminFeaturesEnabled: (state) =>
    !isSupportMode() &&
    Object.prototype.hasOwnProperty.call(state, 'accessDetails') &&
    Object.prototype.hasOwnProperty.call(state.accessDetails, 'isMazlanAdminFeaturesEnabled') &&
    state.accessDetails.isMazlanAdminFeaturesEnabled,

  isMazlanClientFeaturesEnabled: (state) =>
    !isSupportMode() &&
    Object.prototype.hasOwnProperty.call(state, 'accessDetails') &&
    Object.prototype.hasOwnProperty.call(state.accessDetails, 'isMazlanClientFeaturesEnabled') &&
    state.accessDetails.isMazlanClientFeaturesEnabled,

  userLoginMessage: (state) => {
    if (
      Object.prototype.hasOwnProperty.call(state, 'accessDetails') &&
      Object.prototype.hasOwnProperty.call(state.accessDetails, 'userLoginMessage')
    ) {
      const { userLoginMessage } = state.accessDetails;
      return userLoginMessage === '' ? null : userLoginMessage;
    }
    return null;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
